<ng-container *transloco="let t">
    <div class="main-content !p-0">
        <us-product-photo *ngIf="productStore.photos$ | async as photos; else loading"
                          [photos]="photos"
                          class="block mb-6"></us-product-photo>
        <div tuiSheetHeading>
            <div class="mb-2 flex gap-2 font-inter font-extrabold text-[20px] md:text-2xl text-black tracking-tight">
                <h2 class="flex-auto text-[20px] md:text-2xl">
                    {{ productStore.productName$ | async }}
                </h2>
                <p class="flex-none"
                   *ngrxLet="productStore.selectedUnit$ as unit">
                    {{ unit?.price || 0 | formatCurrency }}
                </p>
            </div>
        </div>
        <section>
            <div class="grid md:grid-cols-3 gap-8">
                <ng-template #loading>
                    <div class="bg-slate-200 h-[480px] w-[480px]"></div>
                </ng-template>

                <div class="product-detail md:col-span-2">
                    <div class="food-option">
                        <div class="food-option-title">
                            <p>{{ 'unit' | transloco }}</p>
                        </div>

                        <div class="food-option-content"
                             *tuiLet="productStore.selectedUnitId$ | async as selectedUnitId">
                            <tui-radio-block *ngFor="let unit of productStore.units$ | async"
                                             [ngModel]="selectedUnitId"
                                             (ngModelChange)="productStore.setUnitId($event)"
                                             [item]="unit.id"
                                             size="m"
                                             [hideRadio]="true">
                                <span>{{ unit.name + ' + ' + (unit.price | formatCurrency) }}</span>
                                <span *ngIf="unit.old_price !== null && unit.old_price > unit.price"
                                      class="text-gray-500 line-through ml-1">
                                    {{ unit.old_price | formatCurrency }}
                                </span>
                                <!--<span
                                    class="badge badge-red"
                                    *ngIf="product && product.discount_percent !== null && product.discount_percent > 0"
                                >
                                    {{ '-' + product.discount_percent + '%' }}
                                </span>-->
                            </tui-radio-block>
                        </div>
                    </div>

                    <ng-container *ngFor="let option of productStore.options$ | async; let optionIndex = index">
                        <div class="food-option">
                            <div class="food-option-title">
                                <p>
                                    {{ option.title }}
                                    <span *ngIf="option.select_type === FoodOptionSelectType.AllowSelectedOne">
                                        ({{ 'select_maximum_v2' | transloco : { value: 1 } }})
                                    </span>
                                    <span *ngIf="option.select_type === FoodOptionSelectType.AllowSelectedMultiple">
                                        ({{ 'select_maximum_v2' | transloco : { value: option.max_choose } }})
                                    </span>
                                </p>
                            </div>

                            <div class="food-option-content">
                                <ng-container [ngSwitch]="option.select_type">
                                    <ng-container *ngSwitchCase="FoodOptionSelectType.NotAllowSelected">
                                        <tui-checkbox-block *ngFor="let item of option.items"
                                                            [ngModel]="true"
                                                            [readOnly]="true"
                                                            size="m"
                                                            [hideCheckbox]="true">
                                            {{ item.name + ' + ' + (item.price | formatCurrency) }}
                                        </tui-checkbox-block>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="FoodOptionSelectType.AllowSelectedOne">
                                        <tui-radio-block *ngFor="let item of option.items"
                                                         [ngModel]="option.selected_item"
                                                         (ngModelChange)="productStore.setSelectedOptionItem({optionIndex, value: $event})"
                                                         [item]="item"
                                                         size="m"
                                                         [identityMatcher]="optionItemIdentityMatcher"
                                                         [hideRadio]="true">
                                            {{
                                            item.name +
                                            (item.price !== 0 ? ' + ' + (item.price | formatCurrency) : '')
                                            }}
                                        </tui-radio-block>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="FoodOptionSelectType.AllowSelectedMultiple">
                                        <tui-checkbox-block *ngFor="let item of option.items; let optionItemIndex = index"
                                                            [ngModel]="item.selected"
                                                            (ngModelChange)="productStore.toggleOptionItem({optionIndex, optionItemIndex})"
                                                            size="m"
                                                            [disabled]="!item.enabled"
                                                            [hideCheckbox]="true">
                                            <div class="flex items-center justify-between gap-1 whitespace-normal">
                                                <span>{{ item.name }}</span>
                                                <span *ngIf="item.price !== 0">+{{ item.price | formatCurrency }}</span>
                                            </div>
                                        </tui-checkbox-block>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngFor="let combo of productStore.comboList$ | async; let comboIndex = index">
                        <div class="food-option">
                            <div class="food-option-title">
                                <p>
                                    {{ combo.title }}
                                    <span *ngIf="combo.select_type === FoodOptionSelectType.AllowSelectedMultiple">
                                        {{ 'select_maximum_v2' | transloco : { value: combo.max_choose } }}
                                    </span>
                                    <span *ngIf="combo.select_type === FoodOptionSelectType.AllowSelectedOne">
                                        {{ 'select_maximum_v2' | transloco : { value: 1 } }}
                                    </span>
                                </p>
                            </div>

                            <div class="food-option-content">
                                <ng-container [ngSwitch]="combo.select_type">
                                    <ng-container *ngSwitchCase="FoodOptionSelectType.NotAllowSelected">
                                        <tui-checkbox-block *ngFor="let item of combo.items"
                                                            [ngModel]="true"
                                                            [readOnly]="true"
                                                            size="m"
                                                            [hideCheckbox]="true">
                                            {{ item.name }}
                                        </tui-checkbox-block>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="FoodOptionSelectType.AllowSelectedOne">
                                        <tui-radio-block *ngFor="let item of combo.items"
                                                         [ngModel]="combo.selected_item"
                                                         (ngModelChange)="productStore.setSelectedComboItem({comboIndex, value: $event})"
                                                         [item]="item"
                                                         size="m"
                                                         [identityMatcher]="comboItemIdentityMatcher"
                                                         [hideRadio]="true">
                                            {{ item.name }}
                                        </tui-radio-block>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="FoodOptionSelectType.AllowSelectedMultiple">
                                        <tui-checkbox-block *ngFor="let item of combo.items; let comboItemIndex = index"
                                                            [ngModel]="item.selected"
                                                            (ngModelChange)="productStore.toggleComboItem({comboIndex, comboItemIndex})"
                                                            size="m"
                                                            [disabled]="!item.enabled"
                                                            [hideCheckbox]="true">
                                            <div class="flex items-center justify-between gap-1 whitespace-normal">
                                                {{ item.name }}
                                            </div>
                                        </tui-checkbox-block>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>

                    <!-- <div class="mt-4">
                        <div class="food-option-title">
                            <p>{{ 'quantity' | transloco }}</p>
                            <ng-container *tuiLet="productStore.quantityInStock$ | async as quantityInStock">
                                <p
                                    class="text-base text-gray-600"
                                    *ngIf="quantityInStock !== null && quantityInStock > 0"
                                >
                                    {{
                                        t('only_n_left', {
                                            value:
                                                quantityInStock / ((productStore.selectedUnit$ | async)?.ratio || 1)
                                                | floor
                                        }) +
                                            ' ' +
                                            ((productStore.selectedUnit$ | async)?.name || (t('product') | lowercase))
                                    }}
                                </p>
                            </ng-container>
                        </div>
                    </div> -->
                    <div class="items-center justify-between py-8">
                        <div class="food-option-title">
                            <p>{{ 'add_messages_to_the_store_v2' | transloco }}</p>
                        </div>
                        <tui-text-area class="w-full min-h-[10rem]"
                                       [ngModel]="productStore.note$ | async"
                                       (ngModelChange)="productStore.setNote($event)"
                                       [expandable]="true"
                                       [maxLength]="100">
                            {{ 'write_messages' | transloco }}
                            <textarea tuiTextfield
                                      maxlength="100"></textarea>
                        </tui-text-area>
                    </div>
                </div>
            </div>
            <div class="mt-8 bg-neutral-100 p-4"
                 *ngIf="productStore.productDescription$ | async as description">
                <h3>{{ 'product_description' | transloco }}</h3>
                <div class="product-description"
                     [innerHTML]="description || ''"></div>
            </div>
        </section>
    </div>

    <div sheetFooter
         *ngrxLet="{
            disabled: disabledAddToCart$,
            total: productStore.totalPrice$,
            quantity: productStore.quantity$
        } as vm">
        <div class="flex gap-2 items-center justify-between md:w-10/12 md:m-auto md:px-4">
            <div class="md:w-2/12 w-4/12">
                <us-number-group *tuiLet="productStore.quantity$ | async as quantity"
                                 [value]="quantity || 0"
                                 (decreaseQuantityClick)="productStore.decreaseQuantity()"
                                 (increaseQuantityClick)="productStore.increaseQuantity()"
                                 [minimumQuantity]="(productStore.minimumQuantity$ | async) || 0"
                                 [maximumQuantity]="
                        ((productStore.maximumQuantity$ | async) || 0) /
                            ((productStore.selectedUnit$ | async)?.ratio || 1) | floor
                    "
                                 [classNameSpan]="'!min-w-[10px]'">
                </us-number-group>
            </div>
            <button
                tuiButton
                type="button"
                appearance="primary"
                size="m"
                [disabled]="vm.disabled || isCloseShop.value"
                (click)="addToCart()"
                class="md:w-10/12 w-8/12"
            >
                {{ (selectedValue ? t('update') : t('add')) + ' &#xb7; ' + (vm.total * vm.quantity | formatCurrency) }}
            </button>
        </div>
    </div>
</ng-container>
